export default __webpack_public_path__ + "4b136575d93c79abf987225e14600ab3.svg";